import React from 'react'
import ReactDOM from 'react-dom/client'
import * as Sentry from '@sentry/react'
import App from './App'
import './index.css'
import { startVersionPolling } from './lib/version'

// One DSN for every deploy; the environment tag separates dev from prod.
Sentry.init({
  dsn: 'https://6befe7f46d428d154c80209f112d2683@sentry.clearminds.se/28',
  environment: import.meta.env.MODE,
  integrations: [Sentry.browserTracingIntegration()],
  tracesSampleRate: 1.0,
  tracePropagationTargets: ['localhost', /^https:\/\/api\.ostrel\.se/],
  // No PII. SDK v11 replaced `sendDefaultPii` (default off) with
  // `dataCollection`, whose defaults are permissive (user/IP, cookies, full
  // headers, request/response bodies). This is the SDK's documented v10
  // baseline, spelled out so nothing new is collected — never leave it unset.
  dataCollection: {
    userInfo: false,
    cookies: false,
    // No headers at all (stricter than the v10 baseline; the SDK masks
    // auth/token/cookie headers regardless, but nothing here needs any).
    httpHeaders: { request: false, response: false },
    httpBodies: [],
    urlQueryParams: { deny: ['forwarded', '-ip', 'remote-', 'via', '-user'] },
    genAI: { inputs: false, outputs: false },
    databaseQueryData: false,
    queues: false,
    graphQL: { document: false, variables: false },
  },
})

// New-deploy detection: polls /version.json and flags a newer build.
startVersionPolling()

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
